package com.pincer.client

const val PRODUCTION_SERVER_URL    = "https://api.pincer.com"
const val PRODUCTION_WEBSOCKET_URL = "wss://api.pincer.com"  // Caddy serves only TLS; port 80 redirects, which websockets don't follow
const val LOCAL_SERVER_URL         = "http://localhost:9000"
const val LOCAL_WEBSOCKET_URL      = "ws://localhost:9000"
// From the Android emulator, the local server is at http://10.0.2.2:9000

/*
Which server a fresh client talks to, before anyone changes it in settings (stored settings always win).
Web clients served from localhost use the local server; the JVM client (the REPL) uses it unless
PINCER_SERVER=production. See mpIsLocalDevelopment. Before September 2026 this meant editing these constants.
*/
val DEFAULT_SERVER_URL:    String get() = if (mpIsLocalDevelopment()) LOCAL_SERVER_URL    else PRODUCTION_SERVER_URL
val DEFAULT_WEBSOCKET_URL: String get() = if (mpIsLocalDevelopment()) LOCAL_WEBSOCKET_URL else PRODUCTION_WEBSOCKET_URL
